<script lang="ts">
	import type { Condition, SearchField } from 'utility/search-fields'
	import type { SvelteSet } from 'svelte/reactivity'

	import { loadConditions as loadInventoryConditions } from 'utility/search-fields'
	import Autocomplete from '@isoftdata/svelte-autocomplete'
	import EditModeControls from 'components/search/EditModeControls.svelte'
	import Pin from 'components/search/Pin.svelte'

	import { onMount, type ComponentProps } from 'svelte'

	interface Props
		extends Omit<ComponentProps<typeof Autocomplete<Condition | null>>, 'options' | 'value' | 'emptyValue'> {
		searchField: SearchField
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: SvelteSet<SearchField['key']> //Required
		conditionList?: Promise<Condition[]> | Condition[]
		condition?: Condition | null
		disabled?: boolean
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		conditionList = $bindable([]),
		condition = $bindable(null),
		disabled = false,
		...rest
	}: Props = $props()

	async function loadConditions() {
		conditionList = loadInventoryConditions()
	}

	onMount(() => {
		loadConditions()
	})
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<Autocomplete
		{...rest}
		label="Condition"
		options={conditionList}
		emptyValue={null}
		disabled={disabled || inEditMode}
		bind:value={condition}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</Autocomplete>
</EditModeControls>
